module.exports = __webpack_public_path__ + "assets/img/yuany.151a17a5.png";